export const eventChat = `<svg   viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 14C7 10.134 10.134 7 14 7H17C20.866 7 24 10.134 24 14V17C24 20.866 20.866 24 17 24H7V14Z" fill="currentColor"/>
</svg>`;
